import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $active?: boolean; $disabled?: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	border-radius: 10px;
	background: ${({ $active }) =>
		$active ? '#1782FF' : 'rgba(255, 255, 255, 0.02)'};
	border: 1px solid rgba(255, 255, 255, 0.05);
	overflow: hidden;

	& > ${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		opacity: ${({ $disabled, $active }) =>
			$disabled ? 0.25 : $active ? 0.75 : 0.5};
	}

	& > img {
		position: absolute;
		right: 10px;
		bottom: 10px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledLevelText = styled(Text)<{ $disabled?: boolean }>`
	font-weight: 700;
	font-size: 16px;
	color: #ffffff;
	opacity: ${({ $disabled }) => ($disabled ? 0.25 : 1)};
`;

const StyledCurrentLevelText = styled(Text)`
	font-size: 14px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledDisabledLevelText = styled(Text)`
	font-size: 14px;
	color: #fabe2c;
`;

export {
	StyledContainer,
	StyledCurrentLevelText,
	StyledDisabledLevelText,
	StyledLevelText,
	StyledTopContainer,
};
